export default "__VITE_ASSET__BLL_0UMR__"